import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Exam|Card|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

type LocNameStart = 'SPExamCatalogCard';
export type SPExamCatalogCardLocNames = `${LocNameStart}TitlePage` | `${LocNameStart}ButtonChange`;

export const spExamCatalogCardLocs: LocDefs<SPExamCatalogCardLocNames> = {
	SPExamCatalogCardTitlePage: {
		defaultValue: 'Exams Catalog',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Exam/Catalogs.Exams.Title.PageTitle',
		...sharedProperties,
	},
	SPExamCatalogCardButtonChange: {
		defaultValue: 'Change',
		description: 'Exam card change button',
		displayPath: `${pathStart}Change`,
		displayType: 'Button',
		legacyName: 'Exam/Catalogs.ExamDetails.Button.ChangeSelectedExam',
		...sharedProperties,
	},
};

export type SPExamCatalogCardLocType = LocMap<SPExamCatalogCardLocNames>;
